import { render, staticRenderFns } from "./ListStudentSMS.vue?vue&type=template&id=80197d54&scoped=true&"
import script from "./ListStudentSMS.vue?vue&type=script&lang=js&"
export * from "./ListStudentSMS.vue?vue&type=script&lang=js&"
import style0 from "./ListStudentSMS.vue?vue&type=style&index=0&id=80197d54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80197d54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataFooter } from 'vuetify/lib/components/VDataIterator';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDataFooter,VDataTable,VIcon,VResponsive,VTooltip})
